import { SERVICE_NAME } from "@/config/serviceNames";
import { requests } from ".";
import { EntityType, Module } from "@/constants";

const CompanyService = {
  getCompanyById: (companyId: string) => {
    return requests(SERVICE_NAME.COMPANIES_API).get(companyId);
  },

  setExperiencedCustomer: (companyId: string) => {
    return requests(SERVICE_NAME.COMPANIES_API)
      .log({
        module: Module.COMPANY,
        entityType: EntityType.COMPANY,
        entityId: companyId,
      })
      .put(`support/${companyId}/experienced-customer`);
  },
};

export default CompanyService;
